import { useTabsInformation } from '@/contexts/RADashboardLayoutContext/hooks'
import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import { RADashboardTabs } from '@/interfaces/raDashboard.interface'
import { Button } from '@mui/material'
import React from 'react'

const DashboardTabs: React.FC<RADashboardTabs> = (props) => {
  const { selectedTab, setSelectedTab } = props;
  const theme = useTheme()
  const tabsInfo = useTabsInformation();

  const isTabSelected = (key: string) => {
    let currentSelected = tabsInfo.initialTab

    if (selectedTab != '') {
      currentSelected = selectedTab
    }

    return key === currentSelected
  }

  const getTabLabel = (key: string) => {
    let label = ''

    let tabSetting = tabsInfo.settings[key]
    if (tabSetting != null) {
      label = tabSetting.label
    }

    return label
  }

  const tabAreaStyle = {
    width: 'fit-content',
    borderRadius: '8px',
    backgroundColor: theme.tabBackground,
    marginBottom: '30px',
  }

  const selectedStyle = {
    margin: 2,
    borderRadius: '8px',
    backgroundColor: theme.tabSelectedBackground,
    color: theme.textPrimary,
    textTransform: 'none' as const,
  }

  const deselectedStyle = {
    margin: 2,
    borderRadius: '8px',
    backgroundColor: 'transparent',
    color: theme.textPrimary,
    textTransform: 'none' as const,
  }

  return (
    <div style={tabAreaStyle}>
      {tabsInfo.order.map((tabKey) => (
        <Button
          key={tabKey}
          style={isTabSelected(tabKey) ? selectedStyle : deselectedStyle}
          onClick={() => {
            setSelectedTab(tabKey)
          }}
        >
          {getTabLabel(tabKey)}
        </Button>
      ))}
    </div>
  )
}

export default DashboardTabs
